/* ZOFF universal UI -- drawers, the real Shopify cart, smart search, header state.
   Loaded (defer) on every page, from layout/zoff.liquid and layout/theme.liquid.

   The design file kept a fake bag in localStorage and sent people to a /cart/<id>:<qty> permalink.
   Here the bag IS the Shopify cart: /cart.js to read, /cart/add.js and /cart/change.js to write, and
   the checkout link is /checkout, which snippets/fs-gokwik.liquid hands to GoKwik.
   Other scripts use window.ZH.add(variantId, qty) and window.ZH.refresh(). */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var money = function (paise) {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: paise % 100 ? 2 : 0 }).format(paise / 100);
  };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; };

  /* ── Dialogs ─────────────────────────────────────────────────────────── */
  var openers = new WeakMap();
  function openDialog(id, opener) {
    var dlg = document.getElementById(id);
    if (!dlg || dlg.open || typeof dlg.showModal !== 'function') return;
    $$('dialog[open]').forEach(function (d) { d.close(); });
    openers.set(dlg, opener || document.activeElement);
    if (id === 'zh-cart') { var t = $('#zh-toast'); if (t) t.hidden = true; refresh(); }
    dlg.showModal();
    document.body.classList.add('zh-modal-open');
    $$('[aria-controls="' + id + '"]').forEach(function (c) { c.setAttribute('aria-expanded', 'true'); });
  }
  function wireDialog(dlg) {
    if (dlg.dataset.zhWired) return; dlg.dataset.zhWired = '1';
    var outside = false;
    var off = function (e) { var b = dlg.getBoundingClientRect(); return e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom; };
    dlg.addEventListener('pointerdown', function (e) { outside = off(e); });
    dlg.addEventListener('click', function (e) { if (outside && off(e)) dlg.close(); outside = false; });
    dlg.addEventListener('close', function () {
      document.body.classList.toggle('zh-modal-open', !!$('dialog[open]'));
      $$('[aria-controls="' + dlg.id + '"]').forEach(function (c) { c.setAttribute('aria-expanded', 'false'); });
      var mount = $('[data-zh-video-mount]', dlg); if (mount) mount.innerHTML = '';
      var o = openers.get(dlg);
      if (!$('dialog[open]') && o && o.isConnected && o.focus) o.focus({ preventScroll: true });
    });
  }
  $$('dialog').forEach(wireDialog);
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-zh-open]');
    if (open) { e.preventDefault(); openDialog(open.getAttribute('data-zh-open'), open); return; }
    var close = e.target.closest('[data-zh-close]');
    if (close) { var d = close.closest('dialog'); if (d) d.close(); }
  });

  /* ── Cart ────────────────────────────────────────────────────────────── */
  var cartBox = $('#zh-cart');
  var state = null, toastTimer;
  function toast(msg) {
    var t = $('#zh-toast'); if (!t) return;
    clearTimeout(toastTimer);
    $('#zh-toast-msg').textContent = msg; t.hidden = false;
    toastTimer = setTimeout(function () { if (!t.contains(document.activeElement)) t.hidden = true; }, 5500);
  }
  function paintCount(count) {
    $$('.zh-bag-count').forEach(function (b) { b.textContent = String(count); b.hidden = !count; });
    $$('.zh-bag').forEach(function (b) { b.setAttribute('aria-label', 'Open bag, ' + count + ' ' + (count === 1 ? 'item' : 'items')); });
  }
  function render(cart) {
    state = cart; paintCount(cart.item_count);
    if (!cartBox) return;
    var list = $('#zh-cart-items'), html = '';
    cart.items.forEach(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      var sep = img.indexOf('?') > -1 ? '&' : '?';
      var sub = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      html += '<li class="zh-cart__item">' +
        (img ? '<img src="' + esc(img + sep + 'width=160') + '" alt="' + esc(it.product_title) + '" width="72" height="96" loading="lazy">' : '<span></span>') +
        '<div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' +
        (sub ? '<p>' + esc(sub) + '</p>' : '') + '<p>' + money(it.final_line_price) + '</p>' +
        '<div class="zh-cart__controls"><div class="zh-qty" role="group" aria-label="' + esc(it.product_title) + ' quantity">' +
        '<button type="button" data-zh-line="' + esc(it.key) + '" data-zh-q="' + (it.quantity - 1) + '" aria-label="Decrease ' + esc(it.product_title) + ' quantity">&minus;</button>' +
        '<output aria-label="Quantity">' + it.quantity + '</output>' +
        '<button type="button" data-zh-line="' + esc(it.key) + '" data-zh-q="' + (it.quantity + 1) + '" aria-label="Increase ' + esc(it.product_title) + ' quantity">+</button></div>' +
        '<button class="zh-remove" type="button" data-zh-line="' + esc(it.key) + '" data-zh-q="0" aria-label="Remove ' + esc(it.product_title) + ' from bag">Remove</button></div></div></li>';
    });
    list.innerHTML = html;
    $('#zh-cart-empty').hidden = cart.item_count > 0;
    $('#zh-cart-summary').hidden = cart.item_count === 0;
    $('#zh-cart-count').textContent = '(' + cart.item_count + ')';
    $('#zh-cart-subtotal').textContent = money(cart.total_price);
  }
  function refresh() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }).catch(function () {});
  }
  function change(key, qty) {
    if (cartBox) cartBox.classList.add('is-busy');
    return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }) })
      .then(function (r) { return r.json(); }).then(function (c) { if (c && c.items) render(c); var s = $('#zh-cart-live'); if (s) s.textContent = 'Bag updated.'; })
      .finally(function () { if (cartBox) cartBox.classList.remove('is-busy'); });
  }
  function add(variantId, qty, title, btn) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { toast((title || (j.items && j.items[0] && j.items[0].product_title) || 'Item') + ' added to bag.'); return refresh(); })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add that right now.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  }
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-zh-line]');
    if (line) { change(line.getAttribute('data-zh-line'), Number(line.getAttribute('data-zh-q'))); return; }
    var a = e.target.closest('[data-zh-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-zh-add'), 1, a.getAttribute('data-zh-title'), a); }
  });
  /* Anything else on the page that changes the cart (the PDP, the collection cards, apps) repaints the
     bag count too: watch fetch and XHR for /cart/ writes instead of asking each of them to tell us. */
  var isWrite = function (u) { return /\/cart\/(add|change|update|clear)/.test(String(u || '')); };
  if (window.fetch) {
    var f0 = window.fetch;
    window.fetch = function (input) {
      var p = f0.apply(this, arguments);
      var u = typeof input === 'string' ? input : input && input.url;
      if (isWrite(u) && u.indexOf('zh=1') < 0) p.then(function () { setTimeout(refresh, 60); }).catch(function () {});
      return p;
    };
  }
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { if (isWrite(u)) this.addEventListener('load', function () { setTimeout(refresh, 60); }); return xo.apply(this, arguments); };
  refresh();
  window.ZH = { add: add, refresh: refresh, open: openDialog, toast: toast, money: money };

  /* ── Header: banner colour while the hero is on screen, cream glass once past it ── */
  var shell = $('#zh-top'), hero = document.getElementById('hero');
  if (shell && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { shell.classList.toggle('is-past-hero', !en[0].isIntersecting); }, { rootMargin: '-90px 0px 0px 0px' }).observe(hero);
  }
  $$('[data-zh-year]').forEach(function (n) { n.textContent = String(new Date().getFullYear()); });

  /* ── Smart search: rotating placeholder + live Shopify predictive results ── */
  var form = $('#zh-search'), input = $('#zh-search-input');
  if (form && input) {
    var cfg = {}; try { cfg = JSON.parse($('#zh-search-data').textContent); } catch (_) {}
    var cycle = cfg.cycle && cfg.cycle.length ? cfg.cycle : ['Garam Masala', 'Turmeric Powder', 'Premium Jeera', 'Chaat Masala'];
    var popular = cfg.popular || [], picks = cfg.products || [];
    var base = 'Search “', ci = 0, chars = cycle[0].length, deleting = true;
    input.placeholder = base + cycle[0] + '”';
    (function tick() {
      if (document.activeElement === input || input.value) { setTimeout(tick, 600); return; }
      var w = cycle[ci]; chars += deleting ? -1 : 1;
      input.placeholder = base + w.slice(0, chars) + (chars ? '”' : '');
      var delay = deleting ? 38 : 80;
      if (!deleting && chars === w.length) { deleting = true; delay = 1700; }
      else if (deleting && chars === 0) { deleting = false; ci = (ci + 1) % cycle.length; delay = 260; }
      setTimeout(tick, delay);
    })();
    input.addEventListener('focus', function () { input.placeholder = 'Search spices, blends & more'; });
    input.addEventListener('blur', function () { if (!input.value) { chars = 0; deleting = false; } });

    var panel = document.createElement('div'); panel.className = 'zh-panel'; panel.id = 'zh-panel'; panel.hidden = true;
    form.appendChild(panel);
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-controls', 'zh-panel');
    var opts = [], active = -1, seq = 0;
    var norm = function (t) { return String(t).toLocaleLowerCase('en-IN'); };
    var hl = function (text, q) { var i = norm(text).indexOf(norm(q)); return i < 0 ? esc(text) : esc(text.slice(0, i)) + '<mark>' + esc(text.slice(i, i + q.length)) + '</mark>' + esc(text.slice(i + q.length)); };
    var sUrl = function (q) { return root + 'search?' + new URLSearchParams({ q: q, type: 'product' }).toString(); };
    var sIcon = '<span class="zh-opt__icon" aria-hidden="true"><svg class="zh-icon"><use href="#zh-i-search"/></svg></span>';
    var optP = function (p, q, i) {
      return '<a class="zh-opt" role="option" id="zh-opt-' + i + '" href="' + esc(p.url) + '" aria-selected="false">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" width="40" height="48" loading="lazy">' : '') +
        '<span class="zh-opt__copy"><span class="zh-opt__title">' + (q ? hl(p.title, q) : esc(p.title)) + '</span><span class="zh-opt__meta">' + esc(p.price || '') + '</span></span></a>';
    };
    function show(on) { panel.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false'); if (!on) { input.removeAttribute('aria-activedescendant'); active = -1; } }
    function paint(html) { panel.innerHTML = html; opts = $$('.zh-opt', panel); active = -1; show(true); }
    function renderEmpty() {
      var h = '';
      if (popular.length) h += '<p class="zh-panel__label">Popular searches</p><div class="zh-chips">' + popular.map(function (p) { return '<button type="button" class="zh-chip" data-term="' + esc(p) + '">' + esc(p) + '</button>'; }).join('') + '</div>';
      if (picks.length) h += '<p class="zh-panel__label">Bestsellers</p><div class="zh-opts" role="listbox" aria-label="Bestsellers">' + picks.map(function (p, i) { return optP(p, '', i); }).join('') + '</div>';
      if (h) paint(h); else show(false);
    }
    function renderQuery(q) {
      var mine = ++seq;
      fetch(root + 'search/suggest.json?' + new URLSearchParams({ q: q, 'resources[type]': 'product', 'resources[limit]': '6', 'resources[options][unavailable_products]': 'last' }).toString(), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (mine !== seq) return;
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [], n = 0;
          var h = '<div class="zh-opts" role="listbox" aria-label="Search suggestions">';
          h += ps.map(function (p) { return optP({ title: p.title, url: p.url, image: p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=96' : p.image, price: p.price ? money(Math.round(Number(p.price) * 100)) : '' }, q, n++); }).join('');
          if (!ps.length) h += '<p class="zh-panel__empty">No quick matches. Try the full store search below.</p>';
          h += '<a class="zh-opt zh-opt--all" role="option" id="zh-opt-' + n + '" href="' + sUrl(q) + '" aria-selected="false">' + sIcon + '<span class="zh-opt__copy"><span class="zh-opt__title">Search all for “' + esc(q) + '”</span><span class="zh-opt__meta">Full ZOFF store</span></span></a></div>';
          paint(h);
        }).catch(function () {});
    }
    var debounce;
    function update() { var q = input.value.trim(); clearTimeout(debounce); if (!q) { renderEmpty(); return; } debounce = setTimeout(function () { renderQuery(q); }, 160); }
    function move(d) {
      if (!opts.length) return;
      if (active > -1) opts[active].setAttribute('aria-selected', 'false');
      active = (active + d + opts.length) % opts.length;
      opts[active].setAttribute('aria-selected', 'true'); input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('focus', update);
    input.addEventListener('input', update);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) update(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); opts[active].click(); }
      else if (e.key === 'Escape' && !panel.hidden) { e.preventDefault(); show(false); }
    });
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('click', function (e) { var c = e.target.closest('.zh-chip'); if (c) { input.value = c.getAttribute('data-term'); input.focus(); update(); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) show(false); });
    input.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== input) show(false); }, 120); });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) { e.preventDefault(); input.focus(); return; } show(false); });
  }
})();

/* ── Accordions: one open at a time ──────────────────────────────────────
   Opening any toggle closes the others of the same group (the nearest container, inside its section, that holds
   more than one). <details> lists everywhere (PDP panels + FAQ, contact/about/article FAQs, the homepage steps) and
   the collection's button toggles (FAQ questions, filter groups) are closed by a click of their own, so each keeps
   its own script. Header, footer, nav, search, dialogs and the cart drawer are left alone. */
(function () {
  'use strict';
  var SKIP = 'header, footer, nav, dialog, predictive-search, .zh-header, .zh-footer, .zh-legacy-header, [data-no-accordion]';
  var BTN = '.fsfa__q, .fscg__ghead';
  var group = function (el, sel) {
    var stop = el.closest('.shopify-section') || document.body, g = el.parentElement;
    while (g && g !== stop && g.querySelectorAll(sel).length < 2) g = g.parentElement;
    return g;
  };
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || d.closest(SKIP)) return;
    var g = group(d, 'details');
    if (!g) return;
    Array.prototype.forEach.call(g.querySelectorAll('details[open]'), function (o) {
      if (o !== d && !o.contains(d) && !d.contains(o) && !o.closest(SKIP)) o.open = false;
    });
  }, true); // toggle does not bubble
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(BTN);
    if (!b || b.closest(SKIP)) return;
    setTimeout(function () { // after the button's own handler has opened it
      if (b.getAttribute('aria-expanded') !== 'true') return;
      var g = group(b, BTN);
      if (!g) return;
      Array.prototype.forEach.call(g.querySelectorAll(BTN), function (o) {
        if (o !== b && o.getAttribute('aria-expanded') === 'true') o.click();
      });
    }, 0);
  });
})();
